import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateRoleMutation as CreateRoleMutationType,
  CreateRoleMutationVariables,
} from "./__generated__/CreateRoleMutation";

const CreateRoleMutation = loader("./CreateRoleMutation.gql");

type CreateRoleMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateRoleMutationType) => void;
}) => ReactElement;

export const CreateRoleMutationProvider: CreateRoleMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateRoleMutationType, CreateRoleMutationVariables>(CreateRoleMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
